/**
 * RESPONSIBILITY: one person to ask about an event.
 *
 * The photograph is what makes this worth a section of its own rather than a line of
 * body text: a name and a role is contact information, and a face is an invitation.
 */
import type { ImageValue } from '@framework/core';
import { Row, Text, Img, Link } from '@framework/core/decorators';

@Row()
export class ContactRow {
  @Text({ label: 'Name', maxLength: 120 })
  name!: string;

  @Text({ label: 'Role', maxLength: 120, description: 'e.g. Children’s Ministry Lead.' })
  role!: string;

  @Img({ label: 'Photo', folder: 'events', maxSizeMb: 12, size: '400 × 400' })
  photo!: ImageValue;

  @Link({ label: 'Link', description: 'Optional. An email address or a page about them.' })
  href!: string;
}
